import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import ArcadeLobby from "@/game/arcade/ArcadeLobby";

// Standalone Quack Arcade — a shareable direct link. Coins bank into the same
// localStorage the city reads, so wins carry into Quack City.
export default function ArcadePage() {
  const nav = useNavigate();
  const initialGame = new URLSearchParams(window.location.search).get("game") || "";
  const onCoin = (n, label) => {
    try { const c = Number(localStorage.getItem("cq_city_coins") || 0) + n; localStorage.setItem("cq_city_coins", String(c)); } catch { /* noop */ }
    toast.success(`+${n} coins · ${label}`);
  };
  const name = (typeof localStorage !== "undefined" && localStorage.getItem("cq_arcade_name")) || "";
  return <ArcadeLobby open onClose={() => nav("/city")} onCoin={onCoin} playerName={name} initialGame={initialGame} />;
}
